import { render } from "./SubscriptionInactive.vue?vue&type=template&id=5d0df00a&scoped=true"
import script from "./SubscriptionInactive.vue?vue&type=script&lang=js"
export * from "./SubscriptionInactive.vue?vue&type=script&lang=js"

import "./SubscriptionInactive.vue?vue&type=style&index=0&id=5d0df00a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0df00a"]])

export default __exports__